import { render, staticRenderFns } from "./member-detail-statistics.vue?vue&type=template&id=979af346&scoped=true&"
import script from "./member-detail-statistics.vue?vue&type=script&lang=js&"
export * from "./member-detail-statistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "979af346",
  null
  
)

export default component.exports